/* RCKITOUT storefront */
(function(){
  var R=window.rk||{money:'£{{amount}}',cart:'/cart',root:'/'};
  var $=function(s,c){return (c||document).querySelector(s);},$$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var root=(R.root||'/').replace(/\/$/,'');

  function money(cents){
    var fmt=R.money||'£{{amount}}';cents=Number(cents)||0;
    var m=fmt.match(/\{\{\s*(\w+)\s*\}\}/);var key=m?m[1]:'amount';
    function f(n,d,ts,ds){var s=(n/100).toFixed(d).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return s.join(ds);}
    var v={amount:f(cents,2,',','.'),amount_no_decimals:f(cents,0,',','.'),amount_with_comma_separator:f(cents,2,'.',','),amount_no_decimals_with_comma_separator:f(cents,0,'.',','),amount_with_apostrophe_separator:f(cents,2,"'",'.')}[key]||f(cents,2,',','.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/,v);
  }
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;}

  /* menu drawer */
  var dr=$('[data-rk-drawer]'),bg=$('[data-rk-burger]');
  function lock(o){document.documentElement.style.overflow=o?'hidden':'';}
  if(dr&&bg){
    var setD=function(o){dr.classList.toggle('is-open',o);dr.setAttribute('aria-hidden',!o);bg.setAttribute('aria-expanded',o);lock(o);};
    bg.addEventListener('click',function(){setD(true);});
    dr.addEventListener('click',function(e){if(e.target===dr||e.target.closest('[data-rk-close]'))setD(false);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')setD(false);});
  }

  /* hero */
  $$('[data-rk-hero]').forEach(function(h){
    var s=$$('[data-rk-slide]',h),d=$$('[data-rk-dot]',h);if(s.length<2)return;
    var sec=parseInt(h.dataset.autoplay||6,10),i=0,t=null;h.style.setProperty('--rk-dur',sec+'s');
    var start=function(){clearTimeout(t);if(!h.classList.contains('is-paused'))t=setTimeout(function(){go(i+1);},sec*1000);};
    var go=function(n){s[i].classList.remove('is-on');d[i]&&d[i].classList.remove('is-on');i=(n+s.length)%s.length;s[i].classList.add('is-on');if(d[i]){void d[i].offsetWidth;d[i].classList.add('is-on');}start();};
    d.forEach(function(b,k){b.addEventListener('click',function(){go(k);});});
    var p=$('[data-rk-prev]',h),nx=$('[data-rk-next]',h);
    p&&p.addEventListener('click',function(){go(i-1);});nx&&nx.addEventListener('click',function(){go(i+1);});
    h.addEventListener('mouseenter',function(){h.classList.add('is-paused');clearTimeout(t);});
    h.addEventListener('mouseleave',function(){h.classList.remove('is-paused');start();});
    var x0=null;h.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    h.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    start();
  });

  /* rows */
  function bindRows(scope){
    $$('[data-rk-row]',scope).forEach(function(r){
      if(r._rk)return;r._rk=1;var sec=r.closest('section');if(!sec)return;
      var step=function(dir){r.scrollBy({left:dir*r.clientWidth*0.8,behavior:'smooth'});};
      var p=$('[data-rk-row-prev]',sec),n=$('[data-rk-row-next]',sec);
      p&&p.addEventListener('click',function(){step(-1);});n&&n.addEventListener('click',function(){step(1);});
    });
  }
  bindRows(document);

  /* qty steppers */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-rk-qty]');if(!b)return;
    var inp=b.parentNode.querySelector('input');if(!inp)return;
    var min=parseInt(inp.min||0,10),v=Math.max(min,(parseInt(inp.value,10)||0)+parseInt(b.dataset.rkQty,10));
    inp.value=v;inp.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* cart drawer */
  var cd=$('[data-rk-cd]');
  function openCart(added){
    if(!cd){location.href=R.cart;return;}
    cd.classList.add('is-open');cd.setAttribute('aria-hidden','false');lock(true);
    var a=$('[data-rk-cd-added]',cd);if(a){a.hidden=!added;if(added){clearTimeout(a._t);a._t=setTimeout(function(){a.hidden=true;},2600);}}
  }
  function closeCart(){if(!cd)return;cd.classList.remove('is-open');cd.setAttribute('aria-hidden','true');lock(false);}
  if(cd){
    cd.addEventListener('click',function(e){if(e.target===cd||e.target.closest('[data-rk-cd-close]'))closeCart();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});
  }
  $$('[data-rk-cart-open]').forEach(function(a){a.addEventListener('click',function(e){if(!cd)return;e.preventDefault();refresh().then(function(){openCart(false);});});});

  function setCount(n){
    $$('[data-rk-count]').forEach(function(c){c.textContent=n;c.hidden=n<1;c.classList.remove('is-bump');void c.offsetWidth;c.classList.add('is-bump');});
    var h=cd&&$('[data-rk-cd-count]',cd);if(h)h.textContent='('+n+')';
  }
  function render(cart){
    if(!cd)return;
    var body=$('[data-rk-cd-body]',cd),foot=$('[data-rk-cd-foot]',cd);
    setCount(cart.item_count);
    if(!cart.item_count){
      body.innerHTML='<div class="rk-cd-empty"><p>Your cart is empty.</p><a class="rk-btn" href="'+root+'/collections/all">Start shopping<span aria-hidden="true">→</span></a></div>';
      foot.hidden=true;return;
    }
    foot.hidden=false;
    body.innerHTML=cart.items.map(function(it,ix){
      var vt=(it.variant_title&&it.variant_title!=='Default Title')?'<span class="rk-cd-var">'+esc(it.variant_title)+'</span>':'';
      var was=it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'';
      return '<div class="rk-cd-item"><a class="rk-cd-img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image,200))+'" alt="" loading="lazy">':'')+'</a>'+
        '<div class="rk-cd-info">'+(it.vendor?'<span class="rk-card-vendor">'+esc(it.vendor)+'</span>':'')+'<a class="rk-cd-title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+vt+
        '<div class="rk-cd-ctrl"><div class="rk-qty"><button type="button" data-rk-qty="-1" aria-label="Decrease">−</button><input type="number" min="0" value="'+it.quantity+'" data-rk-line="'+(ix+1)+'" aria-label="Quantity"><button type="button" data-rk-qty="1" aria-label="Increase">+</button></div>'+
        '<button type="button" class="rk-cd-rm" data-rk-rm="'+(ix+1)+'">Remove</button></div></div>'+
        '<div class="rk-cd-price">'+was+money(it.final_line_price)+'</div></div>';
    }).join('');
    $('[data-rk-cd-total]',cd).textContent=money(cart.total_price);
  }
  function refresh(){return fetch(root+'/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){render(c);return c;});}
  function change(line,qty){
    cd&&cd.classList.add('is-loading');
    return fetch(root+'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();}).then(render).finally(function(){cd&&cd.classList.remove('is-loading');});
  }
  if(cd){
    var deb=null;
    cd.addEventListener('change',function(e){var i=e.target.closest('[data-rk-line]');if(!i)return;clearTimeout(deb);deb=setTimeout(function(){change(parseInt(i.dataset.rkLine,10),Math.max(0,parseInt(i.value,10)||0));},350);});
    cd.addEventListener('click',function(e){var b=e.target.closest('[data-rk-rm]');if(b)change(parseInt(b.dataset.rkRm,10),0);});
    refresh();
  }
  function add(items){
    return fetch(root+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add to cart');return j;});})
      .then(function(){return refresh();}).then(function(){openCart(true);});
  }

  /* card quick add */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-rk-add]');if(!b)return;e.preventDefault();
    b.classList.add('is-busy');
    add([{id:parseInt(b.dataset.rkAdd,10),quantity:1}]).then(function(){b.classList.remove('is-busy');b.classList.add('is-done');setTimeout(function(){b.classList.remove('is-done');},1500);})
      .catch(function(err){b.classList.remove('is-busy');alert(err.message);});
  });

  /* product page */
  var pdp=$('[data-rk-pdp]');
  if(pdp){
    var data=JSON.parse(($('[data-rk-product]',pdp)||{}).textContent||'null');
    var inStock=JSON.parse(($('[data-rk-instock]',pdp)||{}).textContent||'{}');
    var form=$('#rk-pf'),vid=$('[data-rk-vid]',pdp),atc=$('[data-rk-atc]',pdp),lab=$('[data-rk-atc-label]',pdp),err=$('[data-rk-err]',pdp);
    var main=$('[data-rk-main]',pdp);
    $$('[data-rk-thumb]',pdp).forEach(function(t){t.addEventListener('click',function(){if(main){main.style.opacity=0;setTimeout(function(){main.src=t.dataset.rkThumb;main.style.opacity=1;},150);}$$('[data-rk-thumb]',pdp).forEach(function(x){x.classList.toggle('is-on',x===t);});});});
    function current(){
      var sel=$$('[data-rk-opt]:checked',pdp).sort(function(a,b){return a.dataset.rkOpt-b.dataset.rkOpt;}).map(function(i){return i.value;});
      return data.variants.find(function(v){return v.options.every(function(o,k){return o===sel[k];});});
    }
    function update(){
      var v=current();
      $$('[data-rk-opt]:checked',pdp).forEach(function(i){var l=$('[data-rk-optval="'+i.dataset.rkOpt+'"]',pdp);if(l)l.textContent=i.value;});
      if(!v){atc.disabled=true;lab.textContent='Unavailable';return;}
      vid.value=v.id;atc.disabled=!v.available;lab.textContent=v.available?'Add to cart':'Sold out';
      var pr=$('[data-rk-price]',pdp),sale=v.compare_at_price>v.price;
      pr.innerHTML='<b'+(sale?' class="is-sale"':'')+'>'+money(v.price)+'</b>'+(sale?'<s>'+money(v.compare_at_price)+'</s><span class="rk-save">Save '+money(v.compare_at_price-v.price)+'</span>':'');
      var st=$('[data-rk-stock]',pdp),ss=inStock[v.id]||(v.available?'order':'out');if(st){st.hidden=ss==='order';st.innerHTML=ss==='in'?'<i class="ok"></i>In stock — ready to ship':ss==='out'?'<i></i>Out of stock':'';}
      var sku=$('[data-rk-sku]',pdp);if(sku)sku.textContent=v.sku||'';
      if(v.featured_media&&main){main.src=img(v.featured_media.preview_image.src,1400);$$('[data-rk-thumb]',pdp).forEach(function(x){x.classList.toggle('is-on',x.dataset.mediaId==v.featured_media.id);});}
      var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString());
    }
    if(data&&data.variants.length>1){pdp.addEventListener('change',function(e){if(e.target.matches('[data-rk-opt]'))update();});}
    if(form&&cd){
      form.addEventListener('submit',function(e){
        e.preventDefault();err.hidden=true;atc.classList.add('is-busy');
        var q=parseInt((form.querySelector('[name=quantity]')||{}).value,10)||1;
        add([{id:parseInt(vid.value,10),quantity:q}]).then(function(){atc.classList.remove('is-busy');atc.classList.add('is-done');lab.textContent='Added';setTimeout(function(){atc.classList.remove('is-done');lab.textContent='Add to cart';},1600);})
          .catch(function(x){atc.classList.remove('is-busy');err.textContent=x.message;err.hidden=false;});
      });
    }
    var recs=$('[data-rk-recs]');
    if(recs){fetch(recs.dataset.rkRecs).then(function(r){return r.text();}).then(function(t){var d=document.createElement('div');d.innerHTML=t;var s=d.querySelector('.shopify-section')||d;recs.innerHTML=s.innerHTML;bindRows(recs);}).catch(function(){});}
  }

  /* cart page auto-update + collection filters */
  $$('[data-rk-autosubmit]').forEach(function(el){
    var t=null;el.addEventListener('change',function(){clearTimeout(t);t=setTimeout(function(){var f=el.form;if(!f)return;var u=f.querySelector('[data-rk-update]');if(u){u.click();}else{f.submit();}},el.tagName==='SELECT'?0:500);});
  });
  var flt=$('[data-rk-filters]');
  if(flt){flt.addEventListener('change',function(e){if(e.target.type==='checkbox')flt.submit();});
    document.addEventListener('click',function(e){$$('.rk-flt[open]',flt).forEach(function(d){if(!d.contains(e.target))d.removeAttribute('open');});});}
})();
